import { render, staticRenderFns } from "./step5-1.vue?vue&type=template&id=1bbd55d6&scoped=true&"
import script from "./step5-1.vue?vue&type=script&lang=js&"
export * from "./step5-1.vue?vue&type=script&lang=js&"
import style0 from "./step5-1.vue?vue&type=style&index=0&id=1bbd55d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd55d6",
  null
  
)

export default component.exports